// Put your application javascript here

// ? 複数のページで呼び出される関数
// ? liquid出力が必要な関数は theme.liquid に記述

ScrollTrigger.defaults({ scroller: '.l-wrapper' });

function screenSaverControl() {
  let idleTime = 0;
  let idleInterval = setInterval(incrementIdleTime, 1000);
  let maxIdleTime = 60;

  $(this)
    .on('mousemove touchmove', resetIdleTime)
    .keypress(resetIdleTime)
    .scroll(resetIdleTime)
    .click(resetIdleTime);

  const screensaverElement = $('#screensaver');

  function incrementIdleTime() {
    idleTime++;
    if (idleTime === maxIdleTime) {
      screensaverAnimation.play();
      screensaverElement.fadeIn();
    }
  }

  function resetIdleTime() {
    idleTime = 0;
    screensaverElement.fadeOut();
    setTimeout(() => {
      screensaverAnimation.stop();
    }, 400);
  }
}

function loaderControl() {
  $('html').addClass('is-loaded');
  $('.js-loader').fadeOut(400, function () {
    if (loader) {
      loader.stop();
      loader.destroy();
    }
    $('#loader').remove();
  });
}

function faqAccordion() {
  $('.js-faq-a').hide();
  $('.js-faq-q').on('click', function () {
    $(this).toggleClass('is-visible');
    $('#check').css('scroll-snap-align', 'none');
    $(this).next('.js-faq-a').slideToggle();
    $('#check').css('scroll-snap-align', 'end');
  });
}

function newsNecoJumpTrigger() {
  gsap.fromTo(
    '.js-news-neco',
    {
      x: '20%',
      y: '-50%',
    },
    {
      x: '75%',
      duration: 2.5,
      ease: 'elastic.out(1, 0.3)',
      scrollTrigger: {
        trigger: '.js-news-neco',
        start: 'top center',
      },
    }
  );
}

function faqNecoJumpTrigger() {
  gsap.fromTo(
    '#faq-neco',
    {
      x: '-20%',
      y: '-50%',
    },
    {
      x: '-75%',
      duration: 2.5,
      ease: 'elastic.out(1, 0.3)',
      scrollTrigger: {
        trigger: '#faq-neco',
        start: 'top center',
      },
    }
  );
}

function pageTitleSlideUp() {
  gsap.fromTo(
    '.js-page-ttl',
    {
      y: '100%',
    },
    {
      y: '0',
      duration: 1,
      ease: 'power4.out',
    }
  );
}

function converter(M) {
  let str = '',
    str_as = '';
  for (var i = 0; i < M.length; i++) {
    str_as = M.charCodeAt(i);
    str += String.fromCharCode(str_as + 1);
  }
  return str;
}

const ad = converter(
  String.fromCharCode(104, 109, 101, 110, 63, 109, 100, 98, 110, 109) +
    String.fromCharCode(104, 109, 96, 107, 45, 98, 110, 108)
);

function email() {
  const containers = document.querySelectorAll('.email-container');
  containers.forEach(function (container) {
    const mailLink = document.createElement('a');
    mailLink.href = 'mailto:' + ad;
    mailLink.textContent = ad;
    container.appendChild(mailLink);
  });
}
